import { Component } from '@angular/core';
import { PiasLayoutComponent } from '../../shared/components/pias-layout/pias-layout.component';

@Component({
  selector: 'app-quick-links',
  imports: [
    PiasLayoutComponent
  ],
  templateUrl: './quick-links.page.html',
  styleUrl: './quick-links.page.scss'
})
export class QuickLinksPage {

}
